import { useEffect } from "react";
import { useComplementoAcaoStore } from "store/useComplementoAcaoStore";

export const useComplementoAcao = () => {
  const {
    msgError,
    loadingComplementos,
    complementosResolvidos,
    tipologias,
    modalidades,
    modalidadesAcao,
    temas,
    carregarComplementos,
  } = useComplementoAcaoStore();

  useEffect(() => {
    carregarComplementos();
  }, []);

  return {
    msgError,
    loadingComplementos,
    complementosResolvidos,
    tipologias,
    modalidades,
    modalidadesAcao,
    temas,
    carregarComplementos,
  };
};
